<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newReportBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Report cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create px-3"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewReport"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <base-icon name="circled_plus" width="22" height="22"/>
                  Crea
                </b-button
                >
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template
            >
          </template>
          <template #cell(user)="{ item }" v-if="items.length">
            {{ getUser(item.user_id) }}
          </template>
          <template #cell(download)="{ item }" v-if="items.length">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                :title="`${
                item.is_ready.value === 'Y' ? 'Download' : 'In Attesa'
              }`"
                :disabled="item.is_ready.value === 'N'"
                @click="downloadReport(item)"
              >
                <base-icon name="download" width="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
<!--              <b-button-->
<!--                v-if="actions.includes('infomodal')"-->
<!--                size="sm"-->
<!--                variant="lisaweb"-->
<!--                @click="openModal(row.item, row.index, $event.target)"-->
<!--                class="mt-1 mr-1"-->
<!--                title="Modale Dettagli"-->
<!--              >-->
<!--                <base-icon name="eye" width="22"></base-icon>-->
<!--              </b-button>-->

<!--              <b-button-->
<!--                v-if="actions.includes('details')"-->
<!--                size="sm"-->
<!--                variant="lisaweb"-->
<!--                @click="row.toggleDetails"-->
<!--                class="mt-1 mr-1"-->
<!--                :title="-->
<!--                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'-->
<!--                "-->
<!--              >-->
<!--                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>-->
<!--                <b-icon v-else icon="chevron-down"></b-icon>-->
<!--              </b-button>-->

<!--              <b-button-->
<!--                v-if="actions.includes('edit')"-->
<!--                size="sm"-->
<!--                variant="lisaweb"-->
<!--                @click="onEdit(row.item.id)"-->
<!--                class="mt-1 mr-1"-->
<!--                title="Modifica"-->
<!--              >-->
<!--                <base-icon name="edit" width="22"></base-icon>-->
<!--              </b-button>-->
              <b-button
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(importer)="{ item }">
            {{ item.importer_id ? "SI" : "NO" }}
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import template from "./template";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import BaseIcon from "@/components/BaseIcon";
import BaseInputPagination from "../form/BaseInputPagination.vue";
import EmptyTable from "@/components/EmptyTable.vue";

export default {
  name: "GeneratedReports",
  mixins: [StorageGetterMixin],
  extends: template,
  data() {
    return {};
  },
  components: {
    BaseInputPagination,
    BaseIcon,
    EmptyTable,
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newReportBtn: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("users"))
      resources.push(
        this.$store
          .dispatch(`${path}users`)
          .then(() => {
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({preset: "error", text: errMsg});
          })
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    downloadReport(item) {
      const document = item.documents[0];
      this.$emit("report", document);
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewReport() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    getUser(user_id) {
      const user = this.$store.state.auth.users.find(
        (item) => item.id === user_id,
      );
      return user?.username ?? "-";
    },
  },
};
</script>

<style lang="css" scoped></style>
